import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const BalanceScale = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9 13.5999L22.7 12.8999L20.6 7.3999C21.5 6.8999 22 5.9999 22 4.8999C22 4.2999 21.6 3.8999 21 3.8999C20.4 3.8999 20 4.2999 20 4.8999C20 5.4999 19.6 5.8999 19 5.8999C18.6 5.8999 18.3 5.6999 18.1 5.3999C17.6 4.4999 16.6 3.8999 15.5 3.8999H13V2.8999C13 2.2999 12.6 1.8999 12 1.8999C11.4 1.8999 11 2.2999 11 2.8999V3.8999H8.5C7.4 3.8999 6.4 4.3999 5.9 5.3999C5.6 5.8999 5 6.0999 4.5 5.7999C4.2 5.5999 4 5.2999 4 4.8999C4 4.2999 3.6 3.8999 3 3.8999C2.4 3.8999 2 4.2999 2 4.8999C2 5.8999 2.5 6.8999 3.4 7.3999L1.1 13.4999C1 13.6999 1 13.7999 1 13.8999C1 16.0999 2.8 17.8999 5 17.8999C7.2 17.8999 9 16.0999 9 13.8999C9 13.7999 9 13.6999 8.9 13.4999L6.6 7.3999C7 7.0999 7.4 6.7999 7.6 6.2999C7.8 5.9999 8.1 5.8999 8.4 5.8999H11V19.8999H8C7.4 19.8999 7 20.2999 7 20.8999C7 21.4999 7.4 21.8999 8 21.8999H16C16.6 21.8999 17 21.4999 17 20.8999C17 20.2999 16.6 19.8999 16 19.8999H13V5.8999H15.5C15.8 5.8999 16.1 5.9999 16.3 6.2999C16.5 6.6999 16.9 7.0999 17.3 7.3999L15 13.4999C15 13.5999 14.9 13.7999 14.9 13.8999C14.9 16.0999 16.7 17.8999 19 17.7999C21.1 17.7999 22.9 16.0999 22.9 13.9999C23 13.8999 23 13.7999 22.9 13.5999ZM3.4 12.8999L5 8.7999L6.6 12.8999H3.4ZM17.4 12.8999L19 8.7999L20.6 12.8999H17.4Z"
      fill="currentColor"
    />
  </svg>
)

export default BalanceScale
